<div class="col-12 btn-tab category-registrations" [ngClass]="'category-registrations__' + category.sportType">
  <button type="button" class="btn-tab__toggle btn-block sh-block" (click)="toggleRowExpand()">
    <div class="d-flex justify-content-start">
      <div class="sport-label">{{ 'sport.short.' + category.sportType | translate }}</div>
      <div class="category-name">
        {{ category.name }}&nbsp;
        <span *ngIf="waitingListRegistrationsCount === 0">({{acceptedRegistrationsCount}})</span>
        <span *ngIf="waitingListRegistrationsCount > 0">
          ({{acceptedRegistrationsCount}} + {{waitingListRegistrationsCount}})
        </span>
      </div>
    </div>

    <div [ngClass]="{'btn-tab__toggle-btn_active': !isCollapsed}" class="btn-tab__toggle-btn">
      <svg-icon [icon]="'caret'"></svg-icon>
    </div>
  </button>

  <div #desktopIndicator class="d-none d-lg-block category-registrations__desktop-version"></div>

  <div *ngIf="loading" class="d-flex justify-content-center">
    <svg-icon [icon]="'spinner-large'"></svg-icon>
  </div>
  <!-- Desktop version -->
  <div class="d-none d-lg-block" *ngIf="registrationsRendered && desktopVersionVisible">
    <div [(ngbCollapse)]="isCollapsed" class="btn-tab__content sh-block">
      <!--  Header public-->
      <div [sorted]="registrations" defaultSortPredicate="participantName">
        <div class="font-weight-bold row no-margin div-table-header" *ngIf="!hasAdminAccessToEvent()">
          <div class="col-6 col-sm-4 no-padding">
            <div class="div-table-header__item sortable" sortBy="participantName" [direction]="defaultSortDirection">
              <span
                class="div-table-header__title div-table-header__title--sortable sortable__toggle"
                [translate]="'registration.participant'"
              >
                Name
              </span>
            </div>
          </div>

          <div class="col-6 no-padding">
            <div class="div-table-header__item sortable" sortBy="countryOrClub">
              <span
                class="div-table-header__title div-table-header__title--sortable sortable__toggle"
                [translate]="clubColumnTitleKey"
              >
                Club
              </span>
            </div>
          </div>
        </div>
      </div>

      <!--  Header for organizers -->
      <div class="div-table-header" [sorted]="registrations" defaultSortPredicate="participantName">
        <div class="font-weight-bold row no-margin" *ngIf="hasAdminAccessToEvent()">
          <div class="col-3 no-padding">
            <div class="div-table-header__item sortable" sortBy="participantName" [direction]="defaultSortDirection">
              <span
                class="div-table-header__title div-table-header__title--sortable sortable__toggle"
                [translate]="'registration.participant'"
              >
                Name
              </span>
            </div>
          </div>

          <div class="col-3 no-padding">
            <div class="div-table-header__item sortable" sortBy="countryOrClub">
              <span
                class="div-table-header__title div-table-header__title--sortable sortable__toggle"
                [translate]="clubColumnTitleKey"
              >
                Club
              </span>
            </div>
          </div>

          <!--                        <div class="col-2 no-padding">-->
          <!--                            <div class="div-table-header__item">-->
          <!--                                <span class="div-table-header__title">Laitteet</span>-->
          <!--                            </div>-->
          <!--                        </div>-->

          <div class="col-2 no-padding">
            <div class="div-table-header__item">
              <span class="div-table-header__title" [translate]="'registration.clubContactsShort'"></span>
            </div>
          </div>

          <div class="col-2 no-padding">
            <div class="div-table-header__item">
              <span class="div-table-header__title" [translate]="'registration.billingContactsShort'"></span>
            </div>
          </div>
          <div class="col-2 no-padding">
            <div class="div-table-header__item sortable" sortBy="registrationDate">
              <span
                class="div-table-header__title div-table-header__title--sortable sortable__toggle"
                [translate]="'registration.registrationDate'"
              >
                Registration date
              </span>
            </div>
          </div>
        </div>
      </div>

      <!-- component row -->
      <registration-row
        *ngFor="let entry of registrations"
        [event]="event"
        [teamCompetitionEnabled]="teamCompetitionEnabled"
        [isEventOrganizerUser]="hasAdminAccessToEvent()"
        [registration]="entry"
        mode="FULL"
      >
      </registration-row>

      <div *ngIf="waitingListRegistrations.length" class="mt-4 pl-4 pr-4 pb-2 d-flex justify-content-between">
        <div>
          <h3 [translate]="'event.waitingList'">Waiting list</h3>
        </div>
        <div *ngIf="hasAdminAccessToEvent()">
          <button
            class="btn btn-icon"
            [ngClass]="{
                            'category-registrations__promote-button_disabled': waitingListSelectionEmpty,
                            'category-registrations__promote-button_enabled': !waitingListSelectionEmpty
                            }"
            [disabled]="waitingListSelectionEmpty"
            (click)="acceptRegistrations()"
          >
            <svg-icon [icon]="'arrow-up-filled'"></svg-icon>
          </button>
        </div>
      </div>
      <registration-row
        *ngFor="let entry of waitingListRegistrations"
        [event]="event"
        [teamCompetitionEnabled]="teamCompetitionEnabled"
        [isEventOrganizerUser]="hasAdminAccessToEvent()"
        [registration]="entry"
        mode="FULL"
        type="WAITING_LIST"
        (onSelectionChanged)="waitingListRowSelectionChanged($event)"
      >
      </registration-row>
    </div>
  </div>

  <!-- Mobile version -->
  <div class="d-block d-lg-none" *ngIf="registrationsRendered && !desktopVersionVisible">
    <div [(ngbCollapse)]="isCollapsed" class="btn-tab__content sh-block">
      <!-- Table Header -->
      <div [sorted]="registrations" defaultSortPredicate="participantName">
        <div class="font-weight-bold row no-margin div-table-header div-table-header--mobile">
          <div class="col-6 no-padding">
            <div class="div-table-header__item sortable" sortBy="participantName" [direction]="defaultSortDirection">
              <span
                class="div-table-header__title div-table-header__title--sortable sortable__toggle"
                [translate]="'registration.participant'"
              >
                Name
              </span>
            </div>
          </div>

          <div class="col-6 no-padding">
            <div class="div-table-header__item sortable" sortBy="countryOrClub">
              <span
                class="div-table-header__title div-table-header__title--sortable sortable__toggle"
                [translate]="clubColumnTitleKey"
              >
                Club
              </span>
            </div>
          </div>
        </div>
      </div>
      <!-- Table Header -->

      <!-- Table Body -->
      <registration-row
        *ngFor="let entry of registrations; let index = index"
        [event]="event"
        [teamCompetitionEnabled]="teamCompetitionEnabled"
        [isEventOrganizerUser]="hasAdminAccessToEvent()"
        [registration]="entry"
        mode="MOBILE"
        [extraClass]="index % 2 == 0 ? 'odd' : ''"
      >
      </registration-row>

      <div *ngIf="waitingListRegistrations.length" class="pr-2 mt-4 d-flex justify-content-between">
        <div>
          <h3 [translate]="'event.waitingList'">Waiting list</h3>
        </div>
      </div>
      <registration-row
        *ngFor="let entry of waitingListRegistrations"
        [event]="event"
        [teamCompetitionEnabled]="teamCompetitionEnabled"
        [isEventOrganizerUser]="hasAdminAccessToEvent()"
        [registration]="entry"
        mode="MOBILE"
        type="WAITING_LIST"
        (onSelectionChanged)="waitingListRowSelectionChanged($event)"
      >
      </registration-row>
    </div>
  </div>
</div>
